module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-06.71f32054.png";